module.exports = __webpack_public_path__ + "static/media/41.1962852a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/41.jpg
// module id = 602
// module chunks = 0